module.exports = __webpack_public_path__ + "img/MapPicsSpiralValley.d5cec914.webp";